import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from './components/Layout';
import ServiceUnavailablePopup from './components/ServiceUnavailablePopup';
import Home from './components/Home';
import ProductsForm from './components/ProductsForm';
import ProductForm from './components/ProductForm';
import RawMaterialsForm from './components/RawMaterials/RawMaterialsForm';
import FormConfigurationForm from './components/FormConfigurationForm';
import BatchForm from './components/BatchForm';
import BatchProductionForm from './components/BatchProductionForm';
import BenchSheetLauncherForm from './components/BenchSheetLauncherForm';
import DmaSerializationForm from './components/Serialization/DmaSerializationForm';
import KarlFischerCoulometricBenchSheetForm from './components/KarlFischerCoulometricBenchSheetForm';
import KarlFischerTitrationBenchSheetForm from './components/KarlFischerTitrationBenchSheetForm';
import ConductivityBenchSheetForm from './components/ConductivityBenchSheetForm';
import BoilingPointBenchSheetForm from './components/BoilingPointBenchSheetForm';
import GasChromatographyBenchSheetForm from './components/GasChromatographyBenchSheetForm';
import IonChromatographyBenchSheetForm from './components/IonChromatographyBenchSheetForm';
import IndCoupledPlasmaSpecBenchSheetForm from './components/IndCoupledPlasmaSpecBenchSheetForm';
import TotalOrganicCarbonBenchSheetForm from './components/TotalOrganicCarbonBenchSheetForm';
import MeltingPointBenchSheetForm from './components/MeltingPointBenchSheetForm';
import MeltingRangeBenchSheetForm from './components/MeltingRangeBenchSheetForm';
import OpticalRotationBenchSheetForm from './components/OpticalRotationBenchSheetForm';
import PhBenchSheetForm from './components/PhBenchSheetForm';
import MassSpecBenchSheetForm from './components/MassSpecBenchSheetForm';
import RefractiveIndexBenchSheetForm from './components/RefractiveIndexBenchSheetForm';
import ResidueOnEvaporationBenchSheetForm from './components/ResidueOnEvaporationBenchSheetForm';
import ResidueOnIgitionBenchSheetForm from './components/ResidueOnIgitionBenchSheetForm';
import TurbidityBenchSheetForm from './components/TurbidityBenchSheetForm';
import SpecificGravityBenchSheetForm from './components/SpecificGravityBenchSheetForm';
import DensityBenchSheetForm from './components/DensityBenchSheetForm';
import UvVisSpectroscopyBenchSheetForm from './components/UvVisSpectroscopyBenchSheetForm';
import GasChromatographyResidualSolventsBenchSheetForm from './components/GasChromatographResSolventsBenchSheetForm';
import TitrationBenchSheetForm from './components/TitrationBenchSheetForm';
import LossOnDryingBenchSheetForm from './components/LossOnDryingBenchSheetForm';
import QnmrBenchSheetForm from './components/QnmrBenchSheetForm';
import GravimetricBenchSheetForm from './components/GravimetricBenchSheetForm';
import NuclearMagneticResonanceBenchSheetForm from './components/NuclearMagneticResonanceBenchSheetForm';
import HplcBenchSheetForm from './components/HplcBenchSheetForm';
import FtirBenchSheetForm from './components/FtirBenchSheetForm';
import UspRefStandardsForm from './components/Standards/UspRefStandardsForm';
import EpRefStandardsForm from './components/Standards/EpRefStandardsForm';
import Documentation from './components/Documentation';
import DocumentationLauncher from './components/DocumentationLauncher';
import DocumentationEditor from './components/DocumentationEditor';
import UsersForm from './components/UsersForm';
import EnumerationsForm from './components/EnumerationsForm';
import AssetsForm from './components/AssetsForm';
import GlasswareForm from './components/GlasswareForm';
import CalibrationLogbook from './components/CalibrationLogbook';
import CertificatesOfAnalyisForm from './components/CertificatesOfAnalyisForm';
import CoaTools from './components/Coa/CoaTools';
import MasterAssayCalculator from './components/MasterAssayCalculator';
import TicketsForm from './components/TicketsForm';
import ColumnsForm from './components/ColumnsForm';
import GcColumnLogbook from './components/GcColumnLogbook';
import ColumnLogbookLookup from './components/ColumnLogbookLookup';
import AuditHistory from './components/AuditHistory';
import StandardsMaintenance from './components/Standards/StandardsMaintenance';
import LoggingInformation from './components/Logging/LoggingInformationForm';
import CoaParserForm from './components/CoaParserForm';
import CalculatorLauncherForm from './components/CalculatorLauncherForm';
import ResourcesForm from './components/ResourcesForm';
import TablesManagementForm from './components/TablesManagement/TablesManagementForm';
import BenchSheetSettings from './components/BenchSheetSettings';
import NoteViewerFullPage from './components/NoteViewerFullPage';
import ProductionBenchSheetPlanningNotesViewerFullPage from './components/ProductionBenchSheetPlanningNotesViewerFullPage';
import BarcodeReader from './components/BarcodeReader';
import RawMaterialAnalysisForm from './components/RawMaterialAnalysisForm';
import PrintBenchSheetForm from './components/Printing/PrintBenchSheetForm';
import PrintBatchPlanningForm from './components/Printing/PrintBatchPlanningForm';
import MetrologyForm from './components/Metrology/MetrologyForm';
import MethodsForm from './components/Methods/MethodsForm';
import HplcMassSpecCalculatorForm from './components/Calculators/HplcMassSpecCalculatorForm';
import UpcomingCalibrationsScheduler from './components/Metrology/UpcomingCalibrationsScheduler';
import SoftwareRequirementsForm from './components/Testing/SoftwareRequirementsForm';
import ControlledDocuments from './components/ControlledDocuments/ControlledDocuments';

//admin 
import SampleTypesForm from './components/SamplePreparations/SampleTypesForm';

//temp and demos
import DmaDiagram from './components/DmaDiagram';
import LayoutTester from './components/LayoutTester';
import ReactGridDemo from './components/ReactGridDemo';
import DmaDashboard from './components/Dashboards/DmaDashboard';
import WorkflowManagement from './components/Workflow/WorkflowManagementForm';
import MathJaxDocumentationComponent from './components/Documentation/MathJaxDocumentationComponent';
//import { CalculationsTestForm } from './components/Testing/CalculationsTestForm';
import NotificationTester from './components/NotificationTester';
import CalculationsForm from './components/CalculationsForm';
import QnmrCalculatorForm from './components/Calculators/QnmrCalculatorForm';
import MonacoEditorDemo from './components/MonacoEditorDemo';
import BarCodeScannerDemo from './components/BarCodeScannerDemo';
import CasDataLoader from './components/CasDataLoader';
import InstructionsDemo from './components/Demos/InstructionsDemo';
import AzureRelayDemo from './components/Demos/AzureRelayDemo';
import NpiEntryFormDemo from './components/NPI/NpiEntryFormDemo';

//Events System
import EventsLogForm from './components/DmaEvents/EventsLogForm';
import TasksManagementForm from './components/DmaTasks/TasksManagementForm';
import TasksForm from './components/DmaTasks/TasksForm';

//Qualifications

import QualificationsManagement from './components/Qualifications/QualificationsManagement';

//Hazards
import HazardStatementsMaintenanceForm from './components/Safety/HazardStatementsMaintenanceForm';
import PrecautionaryStatementsMaintenanceForm from './components/Safety/PrecautionaryStatementsMaintenanceForm';

//Production
import PackagingMaterialsMaintenance from './components/Production/PackagingMaterialsMaintenance';

//Locations
import LocationsManagementForm from './components/Locations/LocationsManagementForm';

//Navigation
import AdministrationHome from './components/Navigation/AdministrationLauncher';
import StandardsLauncher from './components/Navigation/StandardsLauncher';
import AssetsLauncher from './components/Navigation/AssetsLauncher';
import SettingsLauncher from './components/SettingsLauncher';
import CofALauncher from './components/Navigation/CofALauncher';
import EventsLauncher from './components/Navigation/EventsLauncher';
import SafetyLauncher from './components/Navigation/SafetyLauncher';
//import CalculationsLauncher from './components/Navigation/CalculationsLauncher';

//Dynamics forms
import DynamicsItemsPreparationForm from './components/Dynamics/DynamicsItemsPreparationForm';
import DynamicsApiDemo from './components/Demos/DynamicsApiDemo'; 

//Experimental
import BarCodeReaderDemo from './components/Experimental/BarCodeReaderDemo';
import PubChemDataPortal from './components/ExternalData/PubChemDataPortal';

import { CrudFunctions } from './utilities/crud-functions';

//leave for now
//import LogbookLauncher from './components/LogbookLauncher';

import { Popup as DialogPopup } from 'devextreme-react/popup';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import './custom.css'

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './services/msalConfig';
import ReportDesignerForm from './components/Reports/ReportDesignerForm';

config({ licenseKey });

export default function App() {
    const [showGlobalDialog, setShowGlobalDialog] =
        useState<boolean>();

    const [isServiceUnavailable, setIsServiceUnavailable] = useState<boolean>(false);

    useEffect(() => {
        // Listen for a 503 signal from api fetch wrapper
        const handle503 = () => setIsServiceUnavailable(true);
        window.addEventListener('SHOW_SERVICEUNAVAILABLE_SCREEN', handle503);

        return () => window.removeEventListener('SHOW_SERVICEUNAVAILABLE_SCREEN', handle503);
    }, []);

    const AppRoutes = [
        //<RoleRoute path='/' roles={['']} element={Home} />,
        //<RoleRoute path='/products' roles={['']} element={Products} />,
        //<RoleRoute path='/administration' roles={['Site Admin', 'Raw Materials Team']} element={AdministrationHome} />, 

        { index: true, roles: [''], element: <Home /> },
        { path: '', roles: [''], element: <Home /> },
        { path: '/', roles: [''], element: <Home /> },
        { path: '/home', roles: [''], element: <Home /> },
        { path: '/form-configuration', roles: [''], element: <FormConfigurationForm /> },
        //{ path: '/calculations-launcher', roles: [''], element: <CalculationsLauncher /> },
        { path: '/calculator-launcher', roles: [''], element: <CalculatorLauncherForm /> },
        { path: '/administration', roles: ['Site Admin'], element: <AdministrationHome /> },
        { path: '/standards-launcher', roles: [''], element: <StandardsLauncher /> },
        { path: '/settings-launcher', roles: [''], element: <SettingsLauncher /> },
        { path: '/assets-launcher', roles: [''], element: <AssetsLauncher /> },
        { path: '/products', roles: [''], element: <ProductsForm /> },
        { path: '/serialization', roles: [''], element: <DmaSerializationForm /> },

        { path: '/product/:id?', roles: [''], element: <ProductForm /> },
        { path: '/batch/:id?', roles: [''], element: <BatchForm /> },
        { path: '/rawmaterialanalysis/:id?', roles: [''], element: <RawMaterialAnalysisForm /> },
        { path: '/batch-production/:id?', roles: [''], element: <BatchProductionForm /> },
        { path: '/benchsheetlauncher', roles: [''], element: <BenchSheetLauncherForm /> },
        { path: '/benchsheet/200/:id', roles: [''], element: <BoilingPointBenchSheetForm /> },
        { path: '/benchsheet/300/:id', roles: [''], element: <ConductivityBenchSheetForm /> },
        { path: '/benchsheet/400/:id', roles: [''], element: <DensityBenchSheetForm /> },
        { path: '/benchsheet/500/:id', roles: [''], element: <FtirBenchSheetForm /> },
        { path: '/benchsheet/600/:id', roles: [''], element: <GasChromatographyBenchSheetForm handleError={handleError} /> },
        { path: '/benchsheet/700/:id', roles: [''], element: <GasChromatographyResidualSolventsBenchSheetForm /> },
        { path: '/benchsheet/800/:id', roles: [''], element: <HplcBenchSheetForm /> },
        { path: '/benchsheet/900/:id', roles: [''], element: <IonChromatographyBenchSheetForm /> },
        { path: '/benchsheet/1000/:id', roles: [''], element: <IndCoupledPlasmaSpecBenchSheetForm /> },
        { path: '/benchsheet/1100/:id', roles: [''], element: <KarlFischerCoulometricBenchSheetForm /> },
        { path: '/benchsheet/1200/:id', roles: [''], element: <KarlFischerTitrationBenchSheetForm /> },
        { path: '/benchsheet/1300/:id', roles: [''], element: <LossOnDryingBenchSheetForm /> },
        { path: '/benchsheet/1400/:id', roles: [''], element: <MeltingPointBenchSheetForm /> },
        { path: '/benchsheet/1500/:id', roles: [''], element: <MeltingRangeBenchSheetForm /> },
        { path: '/benchsheet/1600/:id', roles: [''], element: <OpticalRotationBenchSheetForm /> },
        { path: '/benchsheet/1700/:id', roles: [''], element: <PhBenchSheetForm /> },
        { path: '/benchsheet/1800/:id', roles: [''], element: <MassSpecBenchSheetForm /> },
        { path: '/benchsheet/1900/:id', roles: [''], element: <RefractiveIndexBenchSheetForm /> },
        { path: '/benchsheet/2000/:id', roles: [''], element: <ResidueOnEvaporationBenchSheetForm /> },
        { path: '/benchsheet/2100/:id', roles: [''], element: <ResidueOnIgitionBenchSheetForm /> },
        { path: '/benchsheet/2200/:id', roles: [''], element: <SpecificGravityBenchSheetForm /> },
        { path: '/benchsheet/2300/:id', roles: [''], element: <TitrationBenchSheetForm /> },
        { path: '/benchsheet/2400/:id', roles: [''], element: <TotalOrganicCarbonBenchSheetForm /> },
        { path: '/benchsheet/2500/:id', roles: [''], element: <TurbidityBenchSheetForm /> },
        { path: '/benchsheet/2600/:id', roles: [''], element: <UvVisSpectroscopyBenchSheetForm /> },
        { path: '/benchsheet/2700/:id', roles: [''], element: <NuclearMagneticResonanceBenchSheetForm /> },
        { path: '/benchsheet/2800/:id', roles: [''], element: <GravimetricBenchSheetForm /> },
        { path: '/benchsheet/2900/:id', roles: [''], element: <QnmrBenchSheetForm /> },
        { path: '/rawmaterialsform', roles: ['Site Admin', 'Raw Materials Team'], element: <RawMaterialsForm /> },
        { path: '/rawmaterialsform/:id', roles: ['Site Admin', 'Raw Materials Team'], element: <RawMaterialsForm /> },
        { path: '/assets', roles: [''], element: <AssetsForm /> },
        { path: '/glassware', roles: [''], element: <GlasswareForm /> },
        { path: '/calibrationlogbook', roles: [''], element: <CalibrationLogbook /> },
        { path: '/usprefstandards', roles: [''], element: <UspRefStandardsForm /> },
        { path: '/eprefstandards', roles: [''], element: <EpRefStandardsForm /> },
        { path: '/documentation/:id?', roles: [''], element: <Documentation /> },
        { path: '/documentationlauncher', roles: [''], element: <DocumentationLauncher /> },
        { path: '/documentationeditor/:id?', roles: [''], element: <DocumentationEditor /> },
        { path: '/users', roles: [''], element: <UsersForm /> },
        { path: '/enumerations', roles: [''], element: <EnumerationsForm /> },
        { path: '/calculations/:batchId?', roles: [''], element: <CalculationsForm /> },
        { path: '/qnmr-calculator/:calculatorId?', roles: [''], element: <QnmrCalculatorForm /> },
        { path: '/cofalauncher', roles: [''], element: <CofALauncher /> },
        { path: '/certificatesofanalysis', roles: [''], element: <CertificatesOfAnalyisForm /> },
        { path: '/coatools', roles: [''], element: <CoaTools /> },
        { path: '/masterassaycalculator/:batchId?', roles: [''], element: <MasterAssayCalculator /> },
        { path: '/audithistory', roles: [''], element: <AuditHistory /> },
        { path: '/columns', roles: [''], element: <ColumnsForm /> },
        { path: '/gccolumnlogbook/:id?', roles: [''], element: <GcColumnLogbook /> },
        { path: '/standardsmaintenance', roles: [''], element: <StandardsMaintenance /> },
        { path: '/standardsmaintenance/:id?', roles: [''], element: <StandardsMaintenance /> },
        { path: '/methods', roles: [''], element: <MethodsForm /> },
        { path: '/tickets', roles: [''], element: <TicketsForm /> },
        { path: '/logging-information', roles: [''], element: <LoggingInformation /> },
        { path: '/coa-parsing', roles: [''], element: <CoaParserForm /> },
        { path: '/tables-management', roles: [''], element: <TablesManagementForm /> },
        { path: '/resources', roles: [''], element: <ResourcesForm /> },
        { path: '/benchsheet-settings', roles: [''], element: <BenchSheetSettings /> },
        { path: '/note-viewer-fp/:parentId/:noteType', roles: [''], element: <NoteViewerFullPage /> },
        { path: '/pbs-planning-notes-viewer-fp/:productId/:batchId', roles: [''], element: <ProductionBenchSheetPlanningNotesViewerFullPage /> },
        { path: '/notificationTester', roles: [''], element: <NotificationTester /> },
        { path: '/monaco-editor', roles: [''], element: <MonacoEditorDemo /> },
        { path: '/qr-scanner', roles: [''], element: <BarCodeScannerDemo /> },
        { path: '/dma-diagram', roles: [''], element: <DmaDiagram /> },
        { path: '/layout-tester', roles: [''], element: <LayoutTester /> },
        { path: '/reactgrid-demo', roles: [''], element: <ReactGridDemo /> },
        { path: '/print-bench-sheet/:benchSheetId', roles: [''], element: <PrintBenchSheetForm /> },
        { path: '/print-batch-planning/:batchId', roles: [''], element: <PrintBatchPlanningForm /> },
        { path: '/workflow-management', roles: [''], element: <WorkflowManagement /> },
        { path: '/dma-dashboard', roles: [''], element: <DmaDashboard /> },
        { path: '/cas-data', roles: [''], element: <CasDataLoader /> },
        { path: '/metrology/:assetId', roles: [''], element: <MetrologyForm /> },
        { path: '/hplc-mass-spec-calculator/:calculatorId', roles: [''], element: <HplcMassSpecCalculatorForm /> },
        { path: '/upcoming-calibrations', roles: [''], element: <UpcomingCalibrationsScheduler /> },
        { path: '/instructions-demo', roles: [''], element: <InstructionsDemo /> },
        { path: '/controlled-documents', roles: [''], element: <ControlledDocuments /> },

        //Reports Designer
        { path: '/report-designer', roles: [''], element: <ReportDesignerForm /> },
        { path: '/report-designer/:reportId', roles: [''], element: <ReportDesignerForm /> },

        //admin
        { path: '/sample-types-editor', roles: [''], element: <SampleTypesForm /> },

        //Events
        { path: '/events-log', roles: [''], element: <EventsLogForm /> },
        { path: '/tasks-management', roles: [''], element: <TasksManagementForm /> },
        { path: '/tasks', roles: [''], element: <TasksForm /> },

        //Qualifications
        { path: '/qualifications-management', roles: [''], element: <QualificationsManagement /> },

        //Safety
        { path: '/hazards-maintenance', roles: [''], element: <HazardStatementsMaintenanceForm /> },
        { path: '/precautionary-statements-maintenance', roles: [''], element: <PrecautionaryStatementsMaintenanceForm /> },

        //Production
        { path: '/packaging-materials-maintenance', roles: [''], element: <PackagingMaterialsMaintenance /> },

        //Locations
        { path: '/locations-maintenance', roles: [''], element: <LocationsManagementForm /> },

        //Navigation
        { path: '/events-launcher', roles: [''], element: <EventsLauncher /> },
        { path: '/events-launcher', roles: [''], element: <EventsLauncher /> },
        { path: '/safety-launcher', roles: [''], element: <SafetyLauncher /> },

        // Dynamics
        { path: '/dynamics-items-preparation', roles: [''], element: <DynamicsItemsPreparationForm /> },

        // Testing
        { path: '/software-requirements-form', roles: [''], element: <SoftwareRequirementsForm /> },

        //temp and experimental
        { path: '/barcode-reader-demo', roles: [''], element: <BarCodeReaderDemo /> },
        { path: '/mathjax', roles: [''], element: <MathJaxDocumentationComponent /> },
        { path: '/pubchem-data-portal', roles: [''], element: <PubChemDataPortal /> },
        { path: '/azure-relay', roles: [''], element: <AzureRelayDemo /> },
        { path: '/dynamics-api-demo', roles: [''], element: <DynamicsApiDemo /> },        
        { path: '/npi-entry-form-demo', roles: [''], element: <NpiEntryFormDemo /> },       

    ];

    const handle503Retry = async () => {
        try {
            // See if the api is responsive yet
            await CrudFunctions.getData("users/getuserinfo");

            // If we reach this line, the 503 is gone
            setIsServiceUnavailable(false);
        } catch (err) {
            // If it's still 503, the api fetch wrapper will re-trigger the event 
            // or the catch block will just keep the screen up.
            console.log("Still warming up or trying to reach servers...");
        }
    };

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
            loadingComponent={() => <div>Signing you in…</div>}
            errorComponent={AuthErrorFallback}
        >
            <ServiceUnavailablePopup visible={isServiceUnavailable} onRetry={handle503Retry} />

            <Layout>

                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>

                {showGlobalDialog &&
                    <DialogPopup
                        visible={showGlobalDialog}
                        onHiding={hideGlobalDialog}
                        dragEnabled={true}
                        width="20rem" height="18rem"
                        hideOnOutsideClick={false}
                        title="">
                        <div>SOME TEXT</div>
                    </DialogPopup>
                }
            </Layout>
        </MsalAuthenticationTemplate>
    );

    function handleError(message: string) {
        console.log(`IN handle error: ${message} `);
        setShowGlobalDialog(true);
    }

    function hideGlobalDialog() {
        setShowGlobalDialog(false);
    }

    function AuthErrorFallback({ error }: { error: any }) {
        return (
            <div style={{ padding: 24, color: "crimson" }}>
                <h3>Authentication Error</h3>
                <pre>{String(error)}</pre>
            </div>
        );
    }
}